import React, { createContext, useState, useEffect, useContext, useCallback, useRef } from "react";
import { useAuth } from "./AuthContext";

const MetricasContext = createContext();
export const useMetricas = () => useContext(MetricasContext);

export const MetricasProvider = ({ children }) => {
  const { user } = useAuth();

  const [metricas, setMetricas] = useState([]);
  const [loadingMetricas, setLoadingMetricas] = useState(false);
  const [errorMetricas, setErrorMetricas] = useState(null);

  const isFetching = useRef(false);
  const lastUserId = useRef(null);

  const resetMetricas = useCallback(() => {
    setMetricas([]);
    setLoadingMetricas(false);
    setErrorMetricas(null);
    isFetching.current = false;
  }, []);

  const fetchMetricas = useCallback(async () => {
    if (!user?.id || isFetching.current) return;

    isFetching.current = true;
    setLoadingMetricas(true);
    setErrorMetricas(null);

    try {
      // Usamos el endpoint centralizado que ya depuramos
      const response = await fetch("https://apiweb.hitpoly.com/ajax/traerProspectosDashboardController.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ user_id: user.id }),
      });

      const rawText = await response.text();
      
      let data;
      try {
        data = JSON.parse(rawText);
      } catch (e) {
        throw new Error("Respuesta del servidor no válida");
      }

      if (data.success) {
        // Los datos ya vienen con nombrePropietario y nombre_empresa desde el PHP
        setMetricas(data.resultado || []);
      } else {
        throw new Error(data.message || "Error al obtener métricas");
      }
    } catch (err) {
      setErrorMetricas(err.message);
    } finally {
      setLoadingMetricas(false);
      isFetching.current = false;
    }
  }, [user?.id]);

  useEffect(() => {
    if (!user?.id) {
      resetMetricas();
      lastUserId.current = null;
      return;
    }

    if (lastUserId.current !== user.id) {
      lastUserId.current = user.id;
      fetchMetricas();
    }
  }, [user?.id, fetchMetricas, resetMetricas]);

  return (
    <MetricasContext.Provider
      value={{
        metricas,
        loadingMetricas,
        errorMetricas,
        fetchMetricas,
        resetMetricas,
      }}
    >
      {children}
    </MetricasContext.Provider>
  );
};